import React, {Component} from 'react'
import Moment from "moment/moment"
import PropTypes from 'prop-types';
import {_getUsersUseCoupon, _updateCouponStatus} from "../../../../../../services/apis/AdminCouponServices"

class CouponItem extends Component {
    state = {
        usersUseCoupon: 0,
        status: this.props.coupon.status,
        isDisabled: false
    }


    componentDidMount() {
        this._fetchUsersUseCoupon();
    }


    _fetchUsersUseCoupon = () => {
        _getUsersUseCoupon(this.props.coupon.code)
            .then(result => {
                if (result.success) {
                    this.setState({
                        usersUseCoupon: result.data,
                    })
                } else {
                    console.error(result.message)
                }
            })
            .catch(error => {
                console.error(error);
            })
    }

    _handleChangeStatus = () => {
        const {_id} = this.props.coupon;
        const textStatus = this.state.status === 'active' ? 'inactive' : 'active';
        this.setState({
            isDisabled: true,
        })

        _updateCouponStatus(_id, textStatus)
            .then(result => {
                if (result.success) {
                    this.setState({
                        isDisabled: false,
                        status: textStatus,
                    })
                } else {
                    this.setState({
                        isDisabled: false,
                    })
                }
            })
            .catch(error => {
                console.error(error);
                this.setState({
                    isDisabled: false,
                })

            })

    }


    render() {
        const {usersUseCoupon, status, isDisabled} = this.state;
        const {coupon,} = this.props;
        const {code, description, total_redemptions, expired_at, max_redemptions, percent_off, amount_off} = coupon;
        const time_expired = Moment(expired_at);
        const text_max_redemptions = max_redemptions === -1 ? 'unlimited' : max_redemptions;
        const presentTime = new Date();
        const expiredTime = new Date(expired_at);
        let discount = percent_off + ' %';

        if (!!amount_off) {
            discount = amount_off + ' $';
        }

        const disabled = isDisabled || (!!expired_at && presentTime > expiredTime);
        return (
            <tr className={!!expired_at && presentTime > expiredTime ? 'disableRow' : ''}>
                <td>{code}</td>
                <td>{discount}</td>
                <td>{usersUseCoupon}</td>
                <td>{description}</td>
                <td>{total_redemptions} / {text_max_redemptions}</td>
                <td>{!!expired_at ? time_expired.format('h:mm:ss A, DD/MM/YYYY') : 'Forever'}</td>
                <td>
                    {
                        <label className="switch">
                            <input type="checkbox" checked={status === 'active'}
                                   onChange={this._handleChangeStatus}
                                   disabled={disabled}/>
                            <span className="slider round"/>
                        </label>
                    }
                </td>
            </tr>
        )
    }
}

CouponItem.propTypes = {
    coupon: PropTypes.object.isRequired,
}

export default CouponItem;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/coupon/CouponPage/components/CouponItem.js